// extracted by mini-css-extract-plugin
module.exports = {"root":"Note_root__2fQBk","info":"Note_info__2QGsp","note":"Note_note__9ioN4","actions":"Note_actions__nNkFi"};